import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { scrollTo } from 'ui/common/scroller';
import autoBind from 'react-autobind';
import classnames from 'classnames';
import * as styles from './index.module.scss';

export class SideBarItem extends Component {
  static propTypes = {
    scrollToId: PropTypes.string.isRequired,
  };

  constructor(props) {
    super(props);
    autoBind(this);
  }

  onClick(scrollToId) {
    scrollTo(scrollToId, 60);
  }

  render() {
    const { scrollToId, onClick, children, ...other } = this.props;

    return (
      <li
        onClick={() => this.onClick(scrollToId)}
        className={classnames(' ml-auto', styles.sidebarItem)}
        {...other}
      >
        {children}
      </li>
    );
  }
}

export default SideBarItem;
